import { useOpeningOrderIncentives } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useOpeningOrderIncentives";
import { OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { useRetailerMilestone } from "@faire/web/common/hooks";

import { IGateHook } from "./type";

export const useOpeningOrderDiscountCountdownGate: IGateHook = () => {
  const { hasOccurred: hasSeenOrderDiscountCountdownModal } =
    useRetailerMilestone(OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN);
  const {
    isDrivenFromMarketingEmail,
    numberOfHoursRemaining,
    showOpeningOrderIncentives,
  } = useOpeningOrderIncentives();

  if (
    numberOfHoursRemaining &&
    showOpeningOrderIncentives &&
    !hasSeenOrderDiscountCountdownModal &&
    numberOfHoursRemaining < 48 &&
    !isDrivenFromMarketingEmail
  ) {
    return PromoModalType.OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL;
  }

  return undefined;
};
